import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { LogOut, User } from 'lucide-react'

interface NavbarProps {
  onMenuClick?: () => void
}

export function Navbar({ onMenuClick }: NavbarProps) {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <nav className="bg-white shadow-lg border-b border-gray-200 fixed top-0 left-0 right-0 z-50">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Logo e botão do menu */}
          <div className="flex items-center">
            {/* Botão do menu mobile e tablet - visível até md */}
            <button
              onClick={onMenuClick}
              className="inline-flex items-center p-2 mt-2 ms-3 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 transition-colors duration-200"
              aria-label="Abrir menu"
            >
              <span className="sr-only">Open sidebar</span>
              <svg className="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path clipRule="evenodd" fillRule="evenodd" d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"></path>
              </svg>
            </button>

            {/* Logo responsivo */}
            <Link to="/dashboard" className="flex-shrink-0 flex items-center ml-2 md:ml-4">
              <div className="h-8 w-8 md:h-10 md:w-10 rounded-lg flex items-center justify-center overflow-hidden">
                <img 
                  src="/brasao_unifap.png" 
                  alt="UNIFAP" 
                  className="h-8 w-8 md:h-10 md:w-10 object-contain"
                />
              </div>
              <span className="ml-2 md:ml-3 text-lg md:text-xl font-semibold text-gray-900 hidden sm:block">
                Portal de Serviços
              </span>
            </Link>
          </div>

          {/* Menu do usuário responsivo */}
          <div className="flex items-center space-x-2 md:space-x-4">
            <div className="flex items-center space-x-2 text-sm md:text-base text-gray-700">
              <User className="w-4 h-4 md:w-5 md:h-5" />
              <span className="hidden sm:block">Olá, {user?.login || 'Usuário'}</span>
            </div>
            
            <button
              onClick={handleLogout}
              className="flex items-center space-x-1 px-2 py-2 md:px-3 text-sm font-medium text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md transition-colors duration-200"
              title="Sair do sistema"
            >
              <LogOut className="w-4 h-4 md:w-5 md:h-5" />
              <span className="hidden sm:block">Sair</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  )
}
